module.exports = fox._r("fonts/promo-social-icon-set.ttf?6587jk", __webpack_public_path__ + "fonts/1bUETh9.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/promo-social-icon-set.ttf?6587jk
// module id = 565
// module chunks = 2